<script lang="ts" setup>
const props = defineProps<{ data: Category }>()

const { data: businesses, refresh } = useAsyncData(`collection-full-${props.data.collectionId}`, async () => {
  const pb = useNuxtApp().$pb
  const data = await pb.collection('businessesOverview').getFullList<Business>({ filter: pb.filter('categories ~ {:category}', { category: props.data.id }) }).catch(() => [])
  return data
})
</script>

<template>
  <div class="py-64 flex flex-col max-w-7xl mx-auto relative px-6 ">
    <HeadingText
      tag="h1"
      class="text-pink"
    >
      {{ data.name }}
    </HeadingText>
    <Paragraph
      :data="data.description"
      class="text-xl md:text-2xl lg:text-3xl xl:text-4xl mb-6 mt-3"
    />
    <div class="flex flex-col gap-6" v-if="businesses?.length">
      <CollectionBusinessCard
        v-for="business in businesses"
        :key="business.id"
        :data="business"
        class="mb-6"
      />

  </div>
    <div
      v-else
      class="flex justify-center py-12 bg-slate-200 rounded-lg shadow"
    >
      <HeadingText
        tag="h3"
        class="text-primary-700"
      >
        No businesses found
      </HeadingText>
    </div>
  </div>
</template>
